import React from "react"
import RootWrapper from "./src/components/utils/RootWrapper"

import "bootstrap/dist/css/bootstrap.min.css"
import "./src/components/style/layout.css"
import "react-accessible-accordion/dist/fancy-example.css"
import "react-datepicker/dist/react-datepicker.css"


export const wrapRootElement = ({ element }) => {
  return <RootWrapper>{element}</RootWrapper>
}
